import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { StudentDto } from '@oracychampions/api-interfaces';
import { StudentsService } from '../../group/students.service';

export const studentResolver: ResolveFn<StudentDto> = (route) => {
  const studentsService = inject(StudentsService);

  const id = route.params['id'];

  return studentsService.getStudent(id);
};
